import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Message } from 'primereact/message';
import { Captcha } from 'primereact/captcha';
import { Growl } from 'primereact/growl';

import servicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioHttp from '../servicios/ServicioHttp';

export class CambioContrasena extends Component {

	constructor(props) {
		super(props);
		this.state = {
			usuario: {},
			errores: {},
			mostrarContrasenas: false,
			verificaCapchap:false,
			cadenaSolicitudCambiopwd:null
		};
		this.obtenerParametros();
	}
	obtenerParametros = () => {
		let { id } = this.props.match.params;		
		if (servicioObjetos.esObjetoVacio(id)) {
			window.location = "/Capufe";
		}
		servicioHttp.consumirPostHttp('usuario/contrasena/validar_vigencia.json', { cadenaSolicitudCambiopwd: id }).then(response => {
			 if (response.data.error)
				 window.location = "/Capufe";
			
			setTimeout(function(){
				if(!document.getElementById('g-recaptcha-response'))
				   window.location.reload();
			},2000);	 
		}).catch(error => {

		});		
		
	}

	mostrarContrasenas = (mostrarContrasenas) => {
		if (mostrarContrasenas) {
			this.password.inputEl.type = "text";
			this.passwordConfirmacion.inputEl.type = "text";
		} else {
			this.password.inputEl.type = "password";
			this.passwordConfirmacion.inputEl.type = "password";
		}
		this.setState({ mostrarContrasenas: mostrarContrasenas });
	}

	asignarDatos = (event, mayusculas) => {
		servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
	}

	cambiarContrasena = () => {
		let { usuario, tokenCaptcha} = this.state;
        let validacion = this.validarForm(usuario);
		this.setState({ errores: validacion });		
		if (servicioObjetos.esObjetoVacio(validacion)) {
            let usuarioClon=JSON.parse(JSON.stringify(usuario));
			let { id } = this.props.match.params;			
			usuarioClon.token = tokenCaptcha;
            usuarioClon.cadenaSolicitudCambiopwd=id;
            delete usuarioClon.confirmacontrasena;
            delete usuarioClon['confirmacontrasena'];
            servicioHttp
                .consumirPostHttp('/usuario/contrasena/actualizar.json', usuarioClon)
                .then((response) => {
                    this.growl.show({ severity: response.data.error === false ? "success" : "error", summary: "", detail: response.data.mensaje, life: 10000 });
                    if (response.data.error) {
                        this.expireCaptcha();
                    } else {
						this.setState({usuario:{},errores:{}});
						setTimeout(function () {
							window.location = "/Capufe";
						}, 3000);
                    }
                }).catch((e) => {

            });
        }
	}
	
	respuestaCaptcha = (response) => {
        this.setState({
            tokenCaptcha: response.response
        });
    }

    expireCaptcha = () => {
        this.setState({ tokenCaptcha: null });
        this.captcha.reset();
	}
	
	validarForm = (usuario) => {
		const errores = {};
		let { tokenCaptcha } = this.state;
		if (servicioObjetos.esObjetoVacio(tokenCaptcha))
			errores.captcha = 'Debe de resolver el captcha';
		if (!usuario.contrasena)
			errores.contrasena = "La contraseña es requerida";
		if (!usuario.confirmacontrasena)
			errores.confirmacontrasena = "La confirmación de contraseña es requerida";
		if (usuario.contrasena !== usuario.confirmacontrasena)
			errores.confirmacontrasena = "Las contraseñas no coinciden";
		if(!document.getElementById('g-recaptcha-response')){
			errores.captcha = 'Al parecer el captcha no se ha cargado con éxito, es necesario que oprima la tecla F5 o recargue la página';
		}
		return errores;
	};

	render() {
		let { usuario, errores, mostrarContrasenas } = this.state;

		return (<div className="exception-body">
			<Growl ref={(el) => this.growl = el} />
			<div className="exception-type">

			</div>

			<div className="exception-type">

			</div>

			<div className="card exception-panel">
				<h1>Facturación Capufe</h1>
				<h4>Cambio de contraseña</h4>
				<div className="p-col-12">
					<div className="p-grid form-group">
						<div className="p-col-12 p-md-12">
							<span className="md-inputfield">
								<Password ref={el => this.password = el} id="usuario.contrasena" name="usuario.contrasena" value={usuario.contrasena || ""} className={errores.contrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
									promptLabel="Por favor ingresa una contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
								<label>* Nueva Contraseña</label>
								{errores.contrasena ? <div> <Message severity="error" text={errores.contrasena} /> </div> : null}
							</span>
						</div>
						<div className="p-col-12 p-md-12">
							<span className="md-inputfield">
								<Password ref={el => this.passwordConfirmacion = el} id="usuario.confirmacontrasena" name="usuario.confirmacontrasena" value={usuario.confirmacontrasena || ""} className={errores.confirmacontrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
									promptLabel="Por favor confirma la contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
								<label>* Confirma Contraseña</label>
								{errores.confirmacontrasena ? <div> <Message severity="error" text={errores.confirmacontrasena} /> </div> : null}
							</span>
						</div>
						<div className="p-col-12 p-md-12">
							<Checkbox inputId="cb1" checked={mostrarContrasenas} onChange={e => this.mostrarContrasenas(e.checked)} />
							<label htmlFor="cb1" className="p-checkbox-label">Mostrar Contraseñas</label>
						</div>
						<div className={errores.captcha ? 'p-col-12 p-md-12 p-error' : 'p-col-12 p-md-12'}>
							<Captcha ref={(r) => this.captcha = r} siteKey="6Lc5NNIZAAAAAE516_ffb7LZRGAsD6WysJ0YJhOQ" onResponse={this.respuestaCaptcha} onExpire={this.expireCaptcha} language="es"></Captcha>
							{errores.captcha ? <div><Message severity="error" text={errores.captcha} /> </div> : null}
						</div>
					</div>
				</div>
				<Button label="Cambiar contraseña" onClick={this.cambiarContrasena} />
			</div>
		</div>);
	}
}